import { render, staticRenderFns } from "./add-email.vue?vue&type=template&id=132f3ba5&"
import script from "./add-email.vue?vue&type=script&lang=js&"
export * from "./add-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports